<template>
  <div>
    <el-row :gutter="10" class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="6" :md="6">
        <el-select v-model="anoSelected" placeholder="Ano" @change="load">
          <el-option v-for="a in anosDisponiveis" :key="a" :label="String(a)" :value="a"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <el-select v-model="mesSelected" placeholder="Mês" @change="load">
          <el-option v-for="m in mesesDisponiveis" :key="m.value" :label="m.label" :value="m.value"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" class="u-text-right">
        <el-button type="info" plain icon="el-icon-refresh" @click="load">ATUALIZAR</el-button>
      </el-col>
    </el-row>

    <!--
      O painel é POR ESCOLA (`dashboard/{instituicaoId}`), e perfil de rede não tem escola no
      contexto: `load()` desistia na primeira linha e todos os cartões ficavam zerados, sem
      dizer por quê. O seletor só aparece para quem não tem escola no header.
    -->
    <el-row :gutter="10" class="u-mb-20" v-if="ehRede">
      <el-col :xs="24" :sm="24" :md="24">
        <el-select v-model="instituicaoSelecionada" filterable clearable
                   placeholder="Selecione a instituição" style="width:100%;" @change="load">
          <el-option v-for="i in instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-alert v-if="!instId" type="info" :closable="false" show-icon class="u-mb-20"
              title="Selecione a instituição para ver os indicadores do transporte."></el-alert>

    <el-row :gutter="10">
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card-dashboard">
          <div class="card-title">Total de rotas</div>
          <div class="card-value">{{ dados.cards.total_rotas || 0 }}</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card-dashboard">
          <div class="card-title">Alunos transportados</div>
          <div class="card-value">{{ dados.cards.alunos_transportados || 0 }}</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card-dashboard">
          <div class="card-title">Veículos ativos</div>
          <div class="card-value">{{ dados.cards.veiculos_ativos || 0 }}</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6">
        <div class="card-dashboard">
          <div class="card-title">Custo mensal</div>
          <div class="card-value">{{ formatMoney(dados.cards.custo_mensal || 0) }}</div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="u-mt-20">
      <el-col :xs="24" :sm="8" :md="8">
        <div class="card-dashboard">
          <div class="card-title">Custo por aluno</div>
          <div class="card-value">{{ formatMoney(dados.indicadores.custo_por_aluno || 0) }}</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8">
        <div class="card-dashboard">
          <div class="card-title">Custo por km (estim.)</div>
          <div class="card-value">{{ formatMoney(dados.indicadores.custo_por_km || 0) }}</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8">
        <div class="card-dashboard">
          <div class="card-title">Consumo médio (km/l)</div>
          <div class="card-value">{{ formatNumber(dados.indicadores.consumo_medio_km_l || 0) }}</div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="u-mt-20">
      <el-col :xs="24" :sm="12" :md="12">
        <c-panel title="Custo do mês (combustível x manutenção)" titleIcon="fas fa-chart-pie">
          <doughnut-chart :chart-data="chartCustos" :height="160"></doughnut-chart>
        </c-panel>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12">
        <c-panel title="Rotas mais longas (km estim.)" titleIcon="fas fa-chart-bar">
          <bar-chart :chart-data="chartRotas" :height="160"></bar-chart>
        </c-panel>
      </el-col>
    </el-row>

    <!--
      BLOCO Z, item 18 — apólices vencidas ou a vencer em 30 dias. É o que torna o cadastro de
      apólice útil: sem o alerta, ninguém descobre que o seguro caiu antes de precisar dele.
    -->
    <el-row :gutter="15" class="u-mt-15" v-if="apolices.length">
      <el-col :xs="24">
        <c-panel title="Apólices de seguro vencidas ou a vencer" titleIcon="fas fa-shield-alt">
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width:120px;">Placa</th>
                <th>Seguradora</th>
                <th style="width:150px;">Nº apólice</th>
                <th style="width:130px;">Vence em</th>
                <th style="width:130px;" class="u-text-center">Situação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="a in apolices" :key="a.id">
                <td><strong>{{ a.placa }}</strong></td>
                <td>{{ a.seguradora }}</td>
                <td>{{ a.numero_apolice }}</td>
                <td>{{ formatarData(a.vigencia_fim) }}</td>
                <td class="u-text-center">
                  <el-tag v-if="a.dias_para_vencer < 0" type="danger" size="mini">
                    vencida há {{ Math.abs(a.dias_para_vencer) }} dia(s)
                  </el-tag>
                  <el-tag v-else type="warning" size="mini">
                    vence em {{ a.dias_para_vencer }} dia(s)
                  </el-tag>
                </td>
              </tr>
            </tbody>
          </table>
        </c-panel>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue'),
    BarChart: () => import('@/chart/BarChart'),
    DoughnutChart: () => import('@/chart/DoughnutChart')
  },
  data: () => ({
    apolices: [],
    anoSelected: (new Date()).getFullYear(),
    mesSelected: (new Date()).getMonth() + 1,
    anosDisponiveis: [],
    mesesDisponiveis: [
      { value: 1, label: 'JAN' }, { value: 2, label: 'FEV' }, { value: 3, label: 'MAR' },
      { value: 4, label: 'ABR' }, { value: 5, label: 'MAI' }, { value: 6, label: 'JUN' },
      { value: 7, label: 'JUL' }, { value: 8, label: 'AGO' }, { value: 9, label: 'SET' },
      { value: 10, label: 'OUT' }, { value: 11, label: 'NOV' }, { value: 12, label: 'DEZ' }
    ],
    instituicoes: [], instituicaoSelecionada: null,
    dados: { cards: {}, indicadores: {}, rotas_mais_longas: [] },
    chartCustos: {
      labels: ['Combustível', 'Manutenção'],
      datasets: [{ data: [0, 0], backgroundColor: ['#346daa', '#f5a623'] }]
    },
    chartRotas: {
      labels: [],
      datasets: [{ label: 'KM estimado', data: [], backgroundColor: '#50964d' }]
    }
  }),
  computed: {
    /** Perfis de abrangência de rede — os que não têm escola no contexto do header. */
    ehRede () {
      const t = parseInt(this.$store.state.user ? this.$store.state.user.tipo : null)
      return t === 10 || (t > 3 && t <= 8)
    },
    /** A escola escolhida na tela tem precedência sobre a do contexto. */
    instId () {
      if (this.instituicaoSelecionada) return this.instituicaoSelecionada
      const i = this.$store.state.config.instituicao
      return i && i.id ? i.id : null
    }
  },
  mounted () {
    this.carregarApolices()
    this.initAnos()
    if (this.ehRede) this.carregarInstituicoes()
    this.load()
  },
  methods: {
    formatarData (d) { return d ? this.$moment(d).format('DD/MM/YYYY') : '—' },

    /** Item 18 — o backend já recorta pelo escopo do usuário. */
    carregarApolices () {
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/apolice/aVencer`,
                       { dias: 30 }, this.$store.getters.getHeaderAuth)
        .then(r => { this.apolices = (r.data && !r.data.erro) ? r.data : [] })
        .catch(() => { this.apolices = [] })
    },

    carregarInstituicoes () {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`, this.$store.getters.getHeaderAuth)
        .then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : Object.values(r.data || {}) })
        .catch(() => { this.instituicoes = [] })
    },
    initAnos () {
      const y = (new Date()).getFullYear()
      this.anosDisponiveis = [y - 2, y - 1, y, y + 1]
    },
    async load () {
      const instituicaoId = this.instId
      if (!instituicaoId) return
      const url = `${this.$store.state.config.baseUrlApi}/api/transporte-escolar/dashboard/${instituicaoId}?ano=${this.anoSelected}&mes=${this.mesSelected}`
      const res = await this.$axios.get(url, this.$store.getters.getHeaderAuth)
      this.dados = res.data || { cards: {}, indicadores: {}, rotas_mais_longas: [] }

      const combustivel = Number((this.dados.indicadores && this.dados.indicadores.custo_combustivel) || 0)
      const manut = Number((this.dados.indicadores && this.dados.indicadores.custo_manutencao) || 0)
      this.chartCustos = {
        labels: ['Combustível', 'Manutenção'],
        datasets: [{ data: [combustivel, manut], backgroundColor: ['#346daa', '#f5a623'] }]
      }

      const rotas = this.dados.rotas_mais_longas || []
      this.chartRotas = {
        labels: rotas.map(r => r.nome || ('#' + r.id)),
        datasets: [{ label: 'KM estimado', data: rotas.map(r => Number(r.quilometragem_estimada || 0)), backgroundColor: '#50964d' }]
      }
    },
    formatMoney (value) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatNumber (value) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  }
}
</script>

<style scoped>
.card-dashboard{
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  padding: 14px;
}
.card-title{ font-size: 12px; color: #666; }
.card-value{ font-size: 22px; font-weight: 600; margin-top: 6px; }
</style>

